
























import { Component, Vue } from 'vue-property-decorator';
import {
  FilterDTO, CatalogItemFullDTOTypeEnum,
  SupplierDTO, CatalogItemShortDTO,
} from '@/api';
import EditingLayout from '@/layouts/EditingLayout.vue';
import Upload from '@/components/common/Upload.vue';
import CardForm from '@/components/common/CardForm.vue';
import { clientsModule, compilationsModule } from '@/store';
import services from '@/services';
import { Form } from 'element-ui';
import {
  fileReader, getAuthToken, throwError, getAssetUrl,
} from '@/utils';
import axios from 'axios';
import CatalogItemPrice from '@/components/CatalogItemPrice.vue';
// import { fileToBase64 } from 'ts-image-processor';
import ThingForm from './ThingForm.vue';

interface IForm {
  name: string;
  type: CatalogItemFullDTOTypeEnum | undefined;
  brandId: string | undefined;
  categoryId: number | undefined;
  colorId: number | undefined;
  supplierId: string | undefined;
  size: string | undefined;
  price: number | undefined;
  priceDiscount: number | undefined;
  thingUrl: string | undefined;
  temperatureFrom: string | undefined;
  temperatureTo: string | undefined;
}

@Component({
  name: 'edit-thing-page',
  components: {
    EditingLayout,
    ThingForm,
    Upload,
    CardForm,
    CatalogItemPrice,
  },
})
export default class EditThing extends Vue {
  loading = false;

  groupEditing = false;

  categories: FilterDTO[] = [];

  brands: FilterDTO[] = [];

  colors: FilterDTO[] = [];

  genders: FilterDTO[] = [];

  suppliers: SupplierDTO[] = [];

  items: CatalogItemShortDTO[] = [];

  selectedItems: number[] = [];

  get thingTypes() {
    return Object.values(CatalogItemFullDTOTypeEnum);
  }

  get client() {
    return clientsModule.model;
  }

  form: IForm = {
    name: '',
    type: CatalogItemFullDTOTypeEnum.CLOTHES,
    brandId: undefined,
    categoryId: undefined,
    colorId: undefined,
    supplierId: undefined,
    size: '',
    price: undefined,
    priceDiscount: undefined,
    thingUrl: undefined,
    temperatureFrom: undefined,
    temperatureTo: undefined,
  }

  imgUrl: string | null = null;

  async created() {
    this.loading = true;
    const { compilationId, clientId } = this.$route.params;
    try {
      const [categories, brands, suppliers] = await Promise.all([services.catalogService()
        .catalogEndpointGetClientCategoryNames(Number(clientId)).then(({ data }) => data),
      services.catalogService().catalogEndpointGetFilterNames('BRAND').then(({ data }) => data),
      services.catalogService().catalogEndpointGetSuppliersList().then(({ data }) => data)]);
      this.categories = categories;
      this.brands = brands;
      this.suppliers = suppliers;
      await compilationsModule
        .fetchCompilation({ compilationId: Number(compilationId) })
        .then((compilation) => {
          const thing = (compilation.things || [])
            .find(t => t.id === Number(this.$route.params.thingId));
          if (thing) {
            const brandId = this.brands.find(b => b.name === thing.brand)?.id;
            const supplierId = this.suppliers.find(s => s.name === thing.store)?.id;
            Object.assign(this.form, {
              name: '',
              type: CatalogItemFullDTOTypeEnum.CLOTHES,
              brandId,
              categoryId: String(thing.categoryId),
              colorId: 90,
              supplierId,
              size: thing.size,
              price: thing.price,
              priceDiscount: thing.priceDiscount,
              thingUrl: thing.link,
              temperatureFrom: thing.temperatureFrom,
              temperatureTo: thing.temperatureTo,
            });

            this.imgUrl = thing && thing.fileNames && thing.fileNames.length
              ? thing.fileNames[0].fileName || null
              : null;
          }
        });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      this.$notify({ title: 'Ошибка!', message: error, type: 'error' });
    } finally {
      this.loading = false;
    }
  }


  updateForm<K extends keyof IForm>(index: number, propertyName: K, value: IForm[K]) {
    this.form[propertyName] = value;
  }

  onImprove(url: string | null) {
    this.imgUrl = url;
  }

  async onFile(file: File) {
    const [url] = await this.uploadImage([file]);
    this.imgUrl = url;
  }

  addSupplier(item: SupplierDTO) {
    this.suppliers.push(item);
  }

  addBrand(item: FilterDTO) {
    this.brands.push(item);
  }

  async uploadImage(files: File[]) {
    const urls = await Promise.all(files.map(async file => fileReader(file)
      .then(binary => axios.post<string>(`https://rest.styleconcierge.ru/api/story/uploadBackground/${file.name}`, binary, {
        headers: { 'Content-Type': 'application/octet-stream', Authorization: `Bearer ${getAuthToken()}` },
      })
        .catch((e) => {
          throwError('Ошибка загрузки изображений');
          this.loading = false;
          throw new Error(e);
        }))));
    return urls.map(u => u.data);
  }

  async onSubmit() {
    this.loading = true;
    let validatorsResult = false;
    try {
      validatorsResult = await ((this.$refs.form as any).$refs.form as Form).validate();
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
      validatorsResult = false;
    }

    if (validatorsResult) {
      try {
        const { form, imgUrl } = this;
        if (form && imgUrl) {
          const compilationId = Number(this.$route.params.compilationId);
          await services.compilationsApi()
            .compilationEndpointUploadThing(
              Number(this.$route.params.thingId),
              // undefined,
              compilationId,
              form.thingUrl,
              'CLOTHES',
              '',
              String(form.brandId),
              String(form.supplierId),
              46,
              form.size as string,
              form.price,
              form.priceDiscount,
              form.categoryId as number,
              form.temperatureFrom,
              form.temperatureTo,
              imgUrl || undefined,
            );
        }
        this.$router.push({ name: 'compilation-things' });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
        this.$notify({ title: 'Ошибка!', message: error, type: 'error' });
      } finally {
        this.loading = false;
      }
    }
    this.loading = false;
    return null;
  }

  back() {
    this.$router.push({ name: 'compilation-things' });
  }

  getImgUrl(path: string) {
    return getAssetUrl(path);
  }
}
